
import { ISessionState } from './ISessionState';
import { AppUser } from '../../../core/security/model/app-user.model';
import { IdentitySession } from '../../../core/security/model/identity-session.model';

export function userAuthenticationUpdate(state: ISessionState, action: { identitySession: IdentitySession }): ISessionState {
    let newState = unAuthenticatedSate();
    if (action.identitySession) {
        newState = {
            isLoggedIn: true,
            currentUser: action.identitySession.user
        };
    }

    return Object.assign({}, state, newState);

}

export function userLoggedOut(state: ISessionState, action: any): ISessionState {
    const newState = unAuthenticatedSate();
    return Object.assign({}, state, newState);
}

function unAuthenticatedSate() {
    return {
        isLoggedIn: false,
        currentUser: null
    };
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/session/session.reducer.logic.ts